<template>
  <div class="joinR">
    <div class="headPic">
      <img src="@/assets/images/confirm-relationship.png" />
    </div>
    <div class="title">
      加入亲友团
    </div>
    <div class="form">
      <!-- <van-field
        v-model="form.relationText"
        is-link
        readonly
        name="picker"
        label="你是逝者的"
        placeholder="如儿子、女儿"
        @click="onShowPicker"
      /> -->
      <van-field
        v-model="form.fullName"
        name="姓名"
        label="姓名"
        placeholder="请填写姓名"
        :rules="[{ required: true, message: '姓名不能为空' }]"
      />
    </div>
    <div class="submit">
      <van-button type="primary" @click="onSubmit">申请加入</van-button>
    </div>
    <br />
    <br />

    <!-- <van-popup :show="showPicker" position="bottom">
      <ul>
        <li>儿子</li>
        <li>女儿</li>
      </ul>
    </van-popup> -->
    <van-popup
      v-model:show="showPicker"
      closeable
      position="bottom"
      :style="{ padding: '64px' }"
    >
      <!-- <ul v-if="tags!=null" >
      <li v-for="item in tags" :key="item" >{{item.DescName}}</li>
    </ul> -->
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      form: {
        type:"FrienMemberTeamPost",
        mid:"",
        relationText: "",
        relationId: "",
        fullName: "",
      },
      showPicker: false,
      tags: null,
      columns: [],
    };
  },
  props: {
    isShow: Boolean,
  },
  methods: {
    init() {
      var that = this;
      this.$store
        .dispatch({
          type: "getDataDictionaryItemList",
          keyName: "RelativeRelationship",
          PageRows:100
        })
        .then((res) => {
          // console.log(res, "getDataDictionaryItemList");
          res.forEach((item) => {
            that.columns.push({
              text: item.DescName,
              id: item.ID,
            });
          });
        });
    },
    onConfirm(value, index) {
      this.showPicker = false;
      this.form.relationText = value.text;
      this.form.relationId = value.id;
    },
    onCancel() {},
    onShowPicker() {
      this.showPicker = true;
    },
    onSubmit() {
      var that=this;
      // if (this.form.relationId== "") {
      //   //Toast("请选择逝者关系！");
      //   this.$toast("请选择逝者关系！");
      //   return false;
      // }
      if(this.form.fullName=="")
      {
        this.$toast("请填写姓名！");
        //Toast("请填写姓名！");
        return false;
      }
      
      //  console.log(this.form,"FrienMemberTeam");
      this.$store.dispatch(this.form).then(res=>{
        Toast(res.Message)
        if(res.IsSuccess)
        {
          that.$emit('hideEvent',false);
          this.form.relationId="";
          this.form.relationText="";
          this.form.fullName="";
          
        }
      })
    },
  },
  activated(){
    this.form.mid=this.$route.query.id;
  },
  created() {
    this.form.mid=this.$route.query.id;
    this.init();
  },
};
</script>

<style scoped lang="less">
.joinR {
  width: 100%;
  height: 410px;
  // position: fixed;
  // z-index: 999;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: white;
  .title {
    font-size: 16px;
    font-weight: 800;
    padding: 5px 0;
  }
  .submit {
    padding: 10px 0;
  }
}
</style>
